module.exports = __webpack_public_path__ + "9339c381ad88160a48ce90e243713379.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_tag.png
// module id = 21
// module chunks = 0 1 2 3 4